import { createContext, useContext } from "react";

export const GradesContext = createContext();

export const useGradesContext = () => {
  const context = useContext(GradesContext);
  if (!context) {
    throw new Error("useGradesContext must be used within a GradesProvider");
  }
  return context;
};
